import { render, staticRenderFns } from "./sozlesmeyedavet.vue?vue&type=template&id=63b77b1b&"
import script from "./sozlesmeyedavet.vue?vue&type=script&lang=js&"
export * from "./sozlesmeyedavet.vue?vue&type=script&lang=js&"
import style0 from "./sozlesmeyedavet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports